import { motion } from 'framer-motion';
import GradientBackground from '../components/GradientBackground/GradientBackground';
import How from '../components/About/How';
import Why from '../components/About/Why';

const About = () => {
  return (
    <>
      <main className="overflow-hidden relative flex align-center justify-center flex-col">
        <div className="relative flex items-center h-20 md:h-[125px] px-4 sm:px-8 md:px-[60px]">
          <GradientBackground />
          <h1 className="z-10 text-2xl sm:text-3xl md:text-[40px] font-normal">About</h1>
        </div>

        <div className="relative p-4 sm:p-8 md:p-[60px] bg-black text-core-grey-150">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="p-4 sm:p-6 md:p-8 mb-8 bg-core-black-100 border border-core-black-contrast-2 rounded-[24px]"
          >
            <h2 className="text-xl sm:text-2xl md:text-[32px] mb-4 text-minima-orange-2023">
              Integritas
            </h2>
            <p className="mb-6 text-sm sm:text-base">
              Data that has been hashed on a blockchain is immutable and intrinsically more
              valuable.
            </p>
            <h3 className="text-lg sm:text-xl md:text-[24px] mb-4 text-minima-orange-2023">
              What is Integritas?
            </h3>
            <p className="mb-6 text-sm sm:text-base">
              Integritas is a middleware solution designed to provide real-time data verification
              and validation from any minima powered source. Users can upload data, verify it, and
              generate reports in NFT and PDF formats.
            </p>
            <h4 className="text-lg sm:text-xl md:text-[24px] mb-4 text-minima-orange-2023">
              Key Features
            </h4>
            <div className="ml-2 sm:ml-4 md:ml-6">
              <ul className="list-disc list-outside mb-6 flex flex-col gap-4 sm:gap-6">
                <li className="marker:text-minima-orange-2023 text-sm sm:text-base">
                  <strong>Data Verification: </strong>
                  Verifies authenticity of uploaded data.
                </li>
                <li className="marker:text-minima-orange-2023 text-sm sm:text-base">
                  <strong>Blockchain Integration: </strong>
                  Uses Minima's Blockchain for secure verification of data.
                </li>
                <li className="marker:text-minima-orange-2023 text-sm sm:text-base">
                  <strong>Stamping: </strong>
                  Ensures tamper-proof on-chain verification of data . NFT & PDF Reports: Users
                  receive verified reports.
                </li>
              </ul>
            </div>
          </motion.div>

          <h3 className="text-lg sm:text-xl md:text-[24px] text-center text-minima-orange-2023 mb-8">
            How it works
          </h3>
          <How />

          {/* Why use Integritas SECTION */}
          <Why />
        </div>
      </main>
    </>
  );
};

export default About;
